import { DateTime } from "luxon"
import { ChevronLeft, ChevronRight } from "lucide-react"

interface Props {
  selectedMonth: DateTime
  onChange: (month: DateTime) => void
}

const MonthSelector: React.FC<Props> = ({ selectedMonth, onChange }) => {
  const now = DateTime.now()
  const minMonth = now.minus({ months: 12 }).startOf("month")
  const currentMonth = now.startOf("month")

  const isAtMin =
    selectedMonth.startOf("month").toMillis() <= minMonth.toMillis()
  const isAtMax =
    selectedMonth.startOf("month").toMillis() >= currentMonth.toMillis()

  return (
    <div className="flex items-center bg-primary-100 rounded-full px-1 py-1">
      <button
        disabled={isAtMin}
        onClick={() => onChange(selectedMonth.minus({ months: 1 }))}
        className="w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:text-base-dark hover:shadow-sm transition-all disabled:opacity-25 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:shadow-none"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      <span className="font-serif text-sm font-medium min-w-[140px] text-center tracking-wide text-base-dark select-none">
        {selectedMonth.toFormat("MMMM yyyy")}
      </span>
      <button
        disabled={isAtMax}
        onClick={() => onChange(selectedMonth.plus({ months: 1 }))}
        className="w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:text-base-dark hover:shadow-sm transition-all disabled:opacity-25 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:shadow-none"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  )
}

export default MonthSelector
